"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visuallyHidden = exports.getBorder = exports.getMargin = void 0;
const getMargin = ({ theme, margin }) => margin
    ? margin
        .split(' ')
        .map((e) => theme.GAP[e] || e)
        .join(' ')
    : 0;
exports.getMargin = getMargin;
const getBorder = ({ theme, border }) => border
    .split(' ')
    .map((e) => theme.COLOR[e] || e)
    .join(' ');
exports.getBorder = getBorder;
const visuallyHidden = () => ({
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: 0,
});
exports.visuallyHidden = visuallyHidden;
//# sourceMappingURL=utils.js.map